import { useRoleActionDialog } from '../../_shared/useRoleActionDialog';
import { useExternalRolesArchiveMutation } from '../_graphql/useExternalRolesArchiveMutation';
import { useExternalRolesRestoreMutation } from '../_graphql/useExternalRolesRestoreMutation';

import { useTranslations } from '~/modules/settings/i18n/useTranslations';

export type { RoleActionDialogState as CpRoleActionDialogState } from '../../_shared/RoleActionConfirmationDialog';

type UseCpRoleActionDialogOptions = {
  onSuccess?: (
    actionType: 'archive' | 'restore' | 'bulkArchive' | 'bulkRestore',
  ) => void;
};

export function useCustomerPortalRoleActionDialog(
  options?: UseCpRoleActionDialogOptions,
) {
  const t = useTranslations();
  const archiveMutation = useExternalRolesArchiveMutation();
  const restoreMutation = useExternalRolesRestoreMutation();

  return useRoleActionDialog({
    archiveMutation,
    restoreMutation,
    toastMessages: {
      archiveSuccess: (name) =>
        t.customerPortal.roles.dialogs.archive.title(name),
      restoreSuccess: (name) =>
        t.customerPortal.roles.dialogs.restore.title(name),
      bulkArchiveSuccess: (count) =>
        t.customerPortal.roles.dialogs.bulkArchive.title(count),
      bulkRestoreSuccess: (count) =>
        t.customerPortal.roles.dialogs.bulkRestore.title(count),
      error: t.customerPortal.roles.addRoleDialog.messages.error,
    },
    onSuccess: options?.onSuccess,
  });
}
